import { render, staticRenderFns } from "./roleModel.vue?vue&type=template&id=311f04f5"
import script from "./roleModel.vue?vue&type=script&lang=js"
export * from "./roleModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('311f04f5')) {
      api.createRecord('311f04f5', component.options)
    } else {
      api.reload('311f04f5', component.options)
    }
    module.hot.accept("./roleModel.vue?vue&type=template&id=311f04f5", function () {
      api.rerender('311f04f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/roleManage/roleModel.vue"
export default component.exports